import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { ItemCalculationResult } from './item-calculation-result.model';
import { PaymentCalculation } from './payment-calculation.model';
import { TaxTotal } from './tax-total.model';

export const CALCULATION_RESULT_SCHEMA = Object.freeze({
  SUB_TOTAL: 0,
  TOTAL: 0,
  SUBTOTAL_PARTS: 0,
  TOTAL_PARTS: 0,
  SUBTOTAL_LABOR: 0,
  TOTAL_LABOR: 0,
  TOTAL_PAYABLE: 0,
  TOTAL_DISCOUNT: 0,
  TOTAL_TAX: 0,
  TOTAL_WITHHOLDING: 0,
  SUBTOTAL_WITHHOLDING: 0,
  TAXES: List<TaxTotal>([]),
  ITEMS: List<ItemCalculationResult>([]),
  PAYMENTS: PaymentCalculation,
  TRUNCATED: false,
});
const RECORD = generateSchema(CALCULATION_RESULT_SCHEMA);
const KEYS: any = generateKeys(CALCULATION_RESULT_SCHEMA);

export class CalculationResult extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.TAXES,
        value: props.get(KEYS.TAXES)
          ? this.taxes.map((params) => new TaxTotal(params))
          : List<TaxTotal>([]),
      },
      {
        key: KEYS.ITEMS,
        value: props.get(KEYS.ITEMS)
          ? this.items.map((params) => new ItemCalculationResult(params))
          : List<ItemCalculationResult>([]),
      },
      {
        key: KEYS.PAYMENTS,
        value: new PaymentCalculation(this.payments),
      },
    ]);

    return selfModel as CalculationResult;
  }

  get subTotal(): number {
    return this.get(KEYS.SUB_TOTAL);
  }

  get total(): number {
    return this.get(KEYS.TOTAL);
  }

  get subtotalParts(): number {
    return this.get(KEYS.SUBTOTAL_PARTS);
  }

  get subtotalLabor(): number {
    return this.get(KEYS.SUBTOTAL_LABOR);
  }

  get totalPayable(): number {
    return this.get(KEYS.TOTAL_PAYABLE);
  }

  get totalDiscount(): number {
    return this.get(KEYS.TOTAL_DISCOUNT);
  }

  get totalWithholding(): number {
    return this.get(KEYS.TOTAL_WITHHOLDING);
  }

  get subtotalWithholding(): number {
    return this.get(KEYS.SUBTOTAL_WITHHOLDING);
  }

  get taxes(): List<TaxTotal> {
    return this.get(KEYS.TAXES);
  }

  get items(): List<ItemCalculationResult> {
    return this.get(KEYS.ITEMS);
  }

  get payments(): PaymentCalculation {
    return this.get(KEYS.PAYMENTS);
  }

  get amountPaidExcludingFees(): number {
    return this.payments.amountPaidExcludingFees;
  }

  get outstandingBalance(): number {
    return this.payments.outstandingBalance;
  }
}
